const buildPreviewBox = (file, isDocument) => {
  const container = document.createElement('div');
  container.classList.add('offer_file_box');
  container.setAttribute('title', file.name);

  if (isDocument) {
    container.classList.add('offer_document_box');
  } else {
    const image = document.createElement('img');
    image.setAttribute('src', URL.createObjectURL(file));
    container.appendChild(image);
  }

  const removeButton = document.createElement('button');
  removeButton.setAttribute('type', 'button');
  removeButton.classList.add('offer_file_remove_btn');
  container.appendChild(removeButton);

  return { container, removeButton };
};

const bindOfferFileInput = (inputId, previewId, isDocument) => {
  const input = document.getElementById(inputId);
  const previewBox = document.getElementById(previewId);
  if (input === null || previewBox === null) return;

  // Server-rendered preview of the already attached file, restored when the new pick is dropped
  const initialPreview = previewBox.innerHTML;

  input.addEventListener('change', () => {
    const file = input.files[0];
    previewBox.innerHTML = '';
    if (!file) return;

    const { container, removeButton } = buildPreviewBox(file, isDocument);
    previewBox.appendChild(container);

    removeButton.addEventListener('click', () => {
      input.value = null;
      previewBox.innerHTML = initialPreview;
    });
  });
};

document.addEventListener('DOMContentLoaded', function () {
  bindOfferFileInput('offer_image', 'offer_image_preview', false);
  bindOfferFileInput('offer_attachment', 'offer_attachment_preview', true);
});
